export interface HiddenExpression {
  hiddenExpression?: (item: any) => boolean,
}
